import React from 'react';
import pure from 'recompose/pure';
import {
  SvgIcon,
} from 'material-ui';

const PowerPointFileSvg = (props) => (
  <SvgIcon viewBox="0 0 384 512" {...props}>
    <path fill="currentColor" d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm72-60V236c0-6.6 5.4-12 12-12h69.2c36.7 0 62.8 27 62.8 66.3 0 74.3-68.7 66.5-95.5 66.5V404c0 6.6-5.4 12-12 12H132c-6.6 0-12-5.4-12-12zm48.5-87.4h23c7.9 0 13.9-2.4 18.1-7.2 8.5-9.8 8.4-28.5.1-37.8-4.1-4.6-9.9-7-17.4-7h-23.9v52z"></path>
  </SvgIcon>
);
const PowerPointFile = pure(PowerPointFileSvg);
PowerPointFile.displayName = 'PowerPointFile';
PowerPointFile.muiName = 'SvgIcon';

export default PowerPointFile;
